import { Injectable } from '@angular/core';
import { BaseSignalStore } from '@core/state/base-store';
import {
  DeceasedDetailsDto,
  DeceasedDocumentDto,
  DeceasedDto,
  InternationalLawInfoDto
} from '@shared/models/dto/api-dtos';

export interface DeceasedState {
  deceased: DeceasedDto | null;
  details: DeceasedDetailsDto | null;
  internationalLawInfo: InternationalLawInfoDto | null;
  documents: DeceasedDocumentDto[];
}

@Injectable({ providedIn: 'root' })
export class DeceasedStore extends BaseSignalStore<DeceasedState> {
  constructor() {
    super({
      deceased: null,
      details: null,
      internationalLawInfo: null,
      documents: []
    });
  }

  readonly deceased = this.select(state => state.deceased);
  readonly details = this.select(state => state.details);
  readonly internationalLawInfo = this.select(state => state.internationalLawInfo);
  readonly documents = this.select(state => state.documents);

  readonly deceased$ = this.select$(state => state.deceased);
  readonly details$ = this.select$(state => state.details);
  readonly internationalLawInfo$ = this.select$(state => state.internationalLawInfo);
  readonly documents$ = this.select$(state => state.documents);

  setDeceased(deceased: DeceasedDto | null): void {
    this.setState({ deceased });
  }

  setDetails(details: DeceasedDetailsDto | null): void {
    this.setState({ details });
  }

  setInternationalLawInfo(info: InternationalLawInfoDto | null): void {
    this.setState({ internationalLawInfo: info });
  }

  setDocuments(documents: DeceasedDocumentDto[]): void {
    this.setState({ documents });
  }

  override reset(): void {
    super.reset();
    this.setState({
      deceased: null,
      details: null,
      internationalLawInfo: null,
      documents: []
    });
    this.setLoading(false);
    this.setError(null);
  }
}


